import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { HeaderComponent } from '../header/header.component';
import { MobileDrawerComponent } from '../mobile-drawer/mobile-drawer.component';
import { BottomNavComponent } from '../bottom-nav/bottom-nav.component';
import { AuthService } from '../../../core/services/auth.service';
import { BusinessContextService } from '../../../core/services/business-context.service';
import { SocketService } from '../../../core/services/socket.service';

// Reemplaza el `<script>` al final de cada `app/*.html` que hacía
// `document.createElement('script').src='_nav.js'` para pintar sidebar/header/drawer/bottom-nav.
// Es el componente montado en la ruta raíz `''` de app.routes.ts (Fase 2, junto con las
// features) — envuelve el `<router-outlet/>` de cada página protegida por `authGuard`.
//
// También es el punto único de conexión del socket (2026-08-31): se monta una sola vez, ya
// autenticado (authGuard ya corrió), y se destruye cuando el router navega a /auth/login tras un
// logout — no hace falta un guard/effect reactivo aparte, el ciclo de vida del componente ya
// coincide exactamente con el de la sesión.
@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, HeaderComponent, MobileDrawerComponent, BottomNavComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app-shell.component.html',
})
export class AppShellComponent implements OnInit, OnDestroy {
  private readonly authService = inject(AuthService);
  private readonly businessContextService = inject(BusinessContextService);
  private readonly socketService = inject(SocketService);

  readonly isDrawerOpen = signal(false);

  ngOnInit(): void {
    const token = this.authService.accessToken();
    if (!token) return;

    this.socketService.connect(token);
    const businessId = this.businessContextService.activeBusinessId();
    if (businessId) {
      this.socketService.joinBusiness(businessId);
    }
  }

  ngOnDestroy(): void {
    this.socketService.disconnect();
  }

  openDrawer(): void {
    this.isDrawerOpen.set(true);
  }

  closeDrawer(): void {
    this.isDrawerOpen.set(false);
  }
}
